module.exports = __webpack_public_path__ + "static/media/SectionPartners_sm_entertainment.ca92099a.png";